import { html, css, LitElement } from 'lit-element';
import { getFunctions, httpsCallable } from 'firebase/functions';

import { functions } from './intrivity_app.js';
import { INTRIVITY_MASQUERADE, emitEvent, hasRole } from './utility.js' // Assuming this is still needed
import { a11yStyles, disclosureButton, uniqueId } from './a11y.js';
import { t, Localized } from './i18n.js';

import './intrivity-user-search.js';
import './user_edit_dialog.js';
import './user_data_removal_dialog.js';
import '@material/mwc-button';

// Manage Clients
export class IntrivityAdminUsers2 extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            /* Matches the CLIENTS / TRAINER GROUPS panel headers. */
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
            .section-header .disclosure {
                vertical-align: middle;
                margin-left: 8px;
                padding: 4px;
            }
        `];
    }

    static get properties() {
        return {
            user_profile: { type: Object },
            expanded: { type: Boolean },
            _selectedUser: { type: Object },
            _editUserDialogOpen: { type: Boolean },
            _removalDialogOpen: { type: Boolean }
        };
    }

    constructor() {
        super();
        this._panelId = uniqueId('users');
        this.expanded = false;
        this._selectedUser = null;
        this._editUserDialogOpen = false;
        this._removalDialogOpen = false;
        this._selectedUserWasFullyRemoved = false;
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    openUserSearch() {
      const dialog = document.createElement('intrivity-user-search');
      document.body.appendChild(dialog);

      // listen for user selection, then present Masquerade/Edit options
      dialog.addEventListener('user-selected', async (e) => {
        this._selectedUser = e.detail.user;
        // cleanup: close/remove the dialog component if it implements a close()
        if (typeof dialog.close === 'function') dialog.close();
        // remove element from DOM to avoid duplicates
        if (dialog.parentNode) dialog.parentNode.removeChild(dialog);
      });

      dialog.open();
    }

    _masquerade() {
      if (!this._selectedUser) return;
      emitEvent(INTRIVITY_MASQUERADE, { email: this._selectedUser.email }, this);
    }

    _editUser() {
      if (!this._selectedUser) return;
      this._editUserDialogOpen = true;
    }

    _removeData() {
      if (!this._selectedUser) return;
      this._removalDialogOpen = true;
      this._selectedUserWasFullyRemoved = false;
    }

    // A full erasure removes the account itself, so the currently-selected
    // user no longer refers to anything real. Wait for the dialog to close
    // (it shows a result message first) rather than yanking the selection
    // out from under it mid-view.
    _onUserDataRemoved(e) {
      if (e.detail && e.detail.mode === 'full') {
        this._selectedUserWasFullyRemoved = true;
      }
    }

    _onRemovalDialogClosed() {
      this._removalDialogOpen = false;
      if (this._selectedUserWasFullyRemoved) {
        this._selectedUser = null;
        this._selectedUserWasFullyRemoved = false;
      }
    }

    render() {
        return html`

            <h2 class="section-header">
                ${t('adminUsers.title')}
                ${disclosureButton(this.expanded, t('adminUsers.title'), this._panelId, () => { this.expanded = !this.expanded; })}
            </h2>

            ${this.expanded ? html`

                    <mwc-button outlined label=${t('common.search')} @click=${() => this.openUserSearch()}></mwc-button>

                    ${this._selectedUser ? html`
                        <div style="margin-top: 10px;">
                            <strong>${this._selectedUser.displayName || this._selectedUser.email}</strong>
                            <mwc-button dense outlined label=${t('adminUsers.masquerade')} @click=${() => this._masquerade()}></mwc-button>
                            <mwc-button dense outlined label=${t('common.edit')} @click=${() => this._editUser()}></mwc-button>
                            ${hasRole('superadmin', this.user_profile) ? html`
                                <mwc-button dense outlined label=${t('adminUsers.removeData')} @click=${() => this._removeData()}></mwc-button>
                            `: html``}
                        </div>
                    `: html``}

                    <intrivity-user-edit-dialog
                        .user_profile=${this.user_profile}
                        .editingUser=${this._selectedUser}
                        .rolesEditable=${true}
                        .open=${this._editUserDialogOpen}
                        @user-saved=${() => { this._editUserDialogOpen = false; }}
                        @dialog-closed=${() => { this._editUserDialogOpen = false; }}
                    ></intrivity-user-edit-dialog>

                    <intrivity-user-data-removal-dialog
                        .user_profile=${this.user_profile}
                        .targetUser=${this._selectedUser}
                        .open=${this._removalDialogOpen}
                        @user-data-removed=${(e) => this._onUserDataRemoved(e)}
                        @dialog-closed=${() => this._onRemovalDialogClosed()}
                    ></intrivity-user-data-removal-dialog>

            `: html`

            `}

        `
    }

}
if (!customElements.get('intrivity-admin-users2')) customElements.define('intrivity-admin-users2', IntrivityAdminUsers2);
